import React from "react";

import { IgIconButton, IgSelect, IgTextField } from "@intelligems/ig-theme";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import Grid from "@mui/material/Grid";
import { theme } from "@src/theme";

import {
  FILTER_TYPE_OPTIONS,
  TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
} from "../../../components/targeting/utils/constants";

interface UrlParamFilterProps {
  urlParam?: {
    queryParam?: string | null;
    queryParamValue?: string | null;
    queryParamFilterType?: string | null;
  } | null;
  onReset: () => void;
  onUrlParamChange: (
    value: string,
    key: "queryParam" | "queryParamFilterType" | "queryParamValue"
  ) => void;
}

export const UrlParamFilter = ({
  urlParam,
  onUrlParamChange,
  onReset,
}: UrlParamFilterProps) => {
  return (
    <Grid
      container
      direction={"row"}
      columnSpacing={1}
      alignItems={"center"}
      wrap={"nowrap"}
    >
      <Grid>
        <IgSelect
          variant={"outlined"}
          // sx={{ width: "160px" }}
          key={`query-param-key`}
          placeholder={"Parameter"}
          value={urlParam?.queryParam || "ig-empty"}
          onChange={(e: SelectChangeEvent<any>) => {
            onUrlParamChange(e.target.value, "queryParam");
          }}
        >
          {Object.entries({
            ...TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
          }).map(([key, value]) => (
            <MenuItem key={`query-param-key-${key}`} value={key}>
              {value}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      <Grid>
        <IgSelect
          placeholder={"Filter"}
          variant={"outlined"}
          // sx={{ width: "190px" }}
          value={urlParam?.queryParamFilterType || "ig-empty"}
          onChange={(e) => {
            onUrlParamChange(e.target.value, "queryParamFilterType");
          }}
        >
          {Object.entries(FILTER_TYPE_OPTIONS).map(([key, value]) => (
            <MenuItem key={`query-param-filter-${key}`} value={key}>
              {value}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      <Grid>
        <IgTextField
          placeholder={"Value"}
          value={urlParam?.queryParamValue || ""}
          variant={"outlined"}
          disabled={
            urlParam?.queryParamFilterType === "isNotNull" ||
            urlParam?.queryParamFilterType === "isNull"
          }
          onChange={(e) => {
            onUrlParamChange(e.target.value, "queryParamValue");
          }}
        />
      </Grid>
      <Grid size={1}>
        <IgIconButton onClick={onReset} iconType={"clear"} iconSize={16} />
      </Grid>
    </Grid>
  );
};
